import { logger as RNLogs } from 'react-native-logs';

/**
 * Logger - Performance-aware simple logger for React-Native and Expo
 *
 * @see {@link https://github.com/onubo/react-native-logs}
 *
 * @remarks
 * This is in lieu of console.log which is thread blocking and listed as a
 * performance risk in the React Native docs.
 * @see {@link https://reactnative.dev/docs/performance#using-consolelog-statements}
 *
 * @usage
 * ```
 * log.debug("This is a Debug log");
 * log.info("This is an Info log");
 * log.warn("This is a Warning log");
 * log.error("This is an Error log");
 * ```
 *
 * @remarks
 * NOTE: We may want to customize the structured logging at some point, but for now
 * this is just a simple implementation
 * @see {@link https://github.com/onubo/react-native-logs#configuration}
 */

export const logger = RNLogs.createLogger();
